import { ListGuesser, EditGuesser, ShowGuesser } from "react-admin";

import FileIcon from "@mui/icons-material/AttachFile";

import FileCreate from "./FileCreate";

const FileResourceProps = {
	name: "file",
	list: ListGuesser,
	create: FileCreate,
	edit: EditGuesser,
	show: ShowGuesser,
};

export const FileMenuProps = {
	to: "/file",
	primaryText: "Fichiers",
	icon: FileIcon,
};

export default FileResourceProps;
